import { Box, Container, Dialog, Button } from '@mui/material';
import bgFYB from '../images/bgFYB.png';

function SignUpResult() {
  
  return (
    <Container maxWidth="sm"
      sx={{ 
        minHeight: '100vh', 
        backgroundImage: `url(${bgFYB})`,
        backgroundSize: '100% 100%', //(e.g., ''cover', 'contain', '100% 100%')
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        
      </Box>

      <Dialog open={true}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 0'
            , backgroundColor: '#f5dde1' }}>
          <label style={{fontWeight: 'bold'}}>CHÚC MỪNG BẠN</label>
          <div style={{textAlign: 'center', marginTop: '5px', padding: '0 20px'}}>
            <label>Bạn đã có voucher 300.000đ trong tài khoản thành viên.</label>
          </div>
          <div style={{textAlign: 'center', marginTop: '5px', padding: '0 20px'}}>
            <label>Sử dụng ngay tại website vn.triumph.com hoặc cửa hàng gần nhất trong vòng 30 ngày.</label>
          </div>
          <Button
            size='large'
            variant="contained"
            sx={{ mt: 3 }}
            onClick={()=>window.location.href = "https://vn.triumph.com/"}
          >
            Đến website
          </Button>
          <Button
							size='large'
							variant="contained"
							sx={{ mt: 3 }}
              onClick={()=>window.location.href = "https://vn.triumph.com/pages/store-locator/"}
					>
						Cửa hàng gần nhất
					</Button>
        </Box>
      </Dialog>
    </Container>
  );
}

export default SignUpResult;